export enum AccountsTableColumnId {
  ACCOUNT_ID = 'custodian_account_id',
  ACCOUNT_NAME = 'account_name',
  ADVISOR_NAME = 'advisor_name',
  TRADING_STATUS = 'do_not_trade',
  ACCOUNT_NOTES = 'account_notes',
  ACCOUNT_TYPE = 'account_type',
  ACCOUNT_STATUS = 'account_status',
  MOMENT_STATUS = 'moment_status',
  PRIME_BROKERAGE = 'prime_brokerage_enabled',
  PORTFOLIO_VALUE = 'portfolio_value',
  PROPOSAL_STATUS = 'proposal_status',
  CASH_BALANCE = 'cash_balance',
  LAST_ACTIVITY = 'last_activity',
  TAX_STATE = 'tax_state',
  PORTFOLIOS = 'portfolios',
  FI_ASSETS = 'tracked_fi_market_value',
  CASH = 'cash_market_value',
  TOTAL_MARKET_VALUE = 'total_market_value',
  CUSTODIAN = 'custodian_id',
  MANAGEMENT_TYPE = 'management_type',
  AVG_COUPON = 'average_coupon',
  AVG_YTW = 'average_yield_to_worst',
  AVG_BOOK_YTW = 'average_book_ytw',
  AVG_MATURITY = 'average_maturity_in_years',
  AVG_SP_RATING = 'average_sp_rating',
  AVG_DURATION = 'average_duration',
  MODEL_NAME = 'model_name',
  MONEY_MANAGER = 'money_manager',
  PERCENT_UNINVESTED_CASH = 'percent_uninvested_cash',
  MOMENT_ORGANIZATION = 'moment_organization_id',
  MARGIN_ELIGIBILITY = 'margin_eligible',
}

export enum AccountDetailsTabs {
  Summary = 'Summary',
  Holdings = 'Holdings',
  Proposals = 'Proposals',
  CashRaises = 'Cash raises',
  RiskControls = 'Risk Controls',
  Activity = 'Activity',
}

export enum AccountDetailsHoldingsTableColumnId {
  PROPOSED_ACTION = 'proposed_action',
  CUSIP = 'cusip',
  ASSET_CLASS = 'asset_class',
  SLEEVE_ID = 'sleeve_id',
  SLEEVE_NAME = 'sleeve_name',
  ACCRUED = 'accrued',
  ACTIONS = 'actions',
  AVG_COST_BASIS = 'avg_cost_basis',
  COST_BASIS_TOTAL = 'cost_basis_total',
  COUPON = 'coupon',
  CURRENT_PRICE = 'current_price',
  DESCRIPTION = 'description',
  DURATION = 'duration',
  EVAL_PRICE = 'eval_price',
  GAIN_LOSS = 'gain_loss',
  ISSUER = 'issuer',
  ISIN = 'isin',
  INSTRUMENT_ID = 'instrument_id',
  LIMIT_PRICE = 'limit_price',
  MARKET_VALUE = 'market_value',
  MATURITY_DATE = 'maturity_date',
  CURRENT_QUANTITY = 'current_quantity',
  OPEN_QUANTITY = 'open_quantity',
  PRICE_DIFFERENCE = 'price_difference',
  TAX_EFFECTIVE_LIMIT_YTW = 'tax_effective_limit_ytw',
  POST_TAX_LIMIT_YTW = 'post_tax_limit_ytw',
  REMOVE_ORDER = 'remove_order',
  SP_RATING = 'sp_rating',
  SECTOR = 'sector',
  TRADE_STATUS = 'trade_status',
  WEIGHT = 'weight',
  YTW = 'ytw',
  BOOK_YTM = 'book_ytm',
  BOOK_YTC = 'book_ytc',
  BOOK_YTW = 'book_ytw',
}

export enum AccountBarChartTimePeriod {
  Monthly = 'monthly',
  Annual = 'annual',
}

//
// Sleeve Management
//

export enum ModelSelectionListColumnId {
  RADIO = '__radio__',
  STRATEGY_NAME = 'name',
  ORGANIZATION = 'organization',
  STRATEGY_TYPE = 'strategy_type',
  SECURITIES = 'securities',
  ASSET_CLASS = 'asset_class',
  PORTFOLIO_MANAGER = 'portfolio_manager',
  ACCOUNT_MINIMUM = 'account_minimum',
  MODEL_PROGRAM = 'model_program',
}
